import { Plus, Trash2, ChevronUp, ChevronDown, Save } from "lucide-react";
import { useCrud } from "./useCrud";
import { ImageField, Field } from "./ImageField";

export const GroupEditor = ({ path, blankName, tagLabel = "Tag" }) => {
  const { items, patch, add, save, remove, move } = useCrud(path, { name: blankName, tag: "", description: "", image: "" });
  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <p className="text-[#8F877C] text-sm">Add, edit, reorder and remove entries.</p>
        <button onClick={add} data-testid={`${path}-add-btn`} className="inline-flex items-center gap-2 font-feature text-xs uppercase tracking-widest bg-teal text-obsidian px-4 py-2.5 hover:bg-bone transition-colors"><Plus className="h-4 w-4" /> Add</button>
      </div>
      {items.map((it, idx) => (
        <div key={it.id} data-testid={`${path}-edit-${idx}`} className="border border-[#2A201A] bg-surface/40 p-5 space-y-4">
          <div className="grid gap-4 sm:grid-cols-2">
            <Field label="Name" value={it.name} onChange={(v) => patch(it.id, "name", v)} />
            <Field label={tagLabel} value={it.tag} onChange={(v) => patch(it.id, "tag", v)} />
          </div>
          <div>
            <p className="font-mono text-[10px] uppercase tracking-widest text-[#8F877C] mb-2">Description</p>
            <textarea value={it.description || ""} onChange={(e) => patch(it.id, "description", e.target.value)} rows={3}
              className="w-full bg-obsidian border border-[#2A201A] px-3 py-2 text-sm text-bone focus:outline-none focus:border-teal resize-none" />
          </div>
          <ImageField label="Image" value={it.image} onChange={(v) => patch(it.id, "image", v)} />
          <div className="flex items-center gap-2">
            <button onClick={() => save(it)} className="inline-flex items-center gap-2 font-feature text-xs uppercase tracking-widest bg-teal/90 text-obsidian px-4 py-2 hover:bg-teal"><Save className="h-4 w-4" /> Save</button>
            <button onClick={() => move(idx, -1)} className="p-2 border border-[#2A201A] hover:border-teal hover:text-teal transition-colors"><ChevronUp className="h-4 w-4" /></button>
            <button onClick={() => move(idx, 1)} className="p-2 border border-[#2A201A] hover:border-teal hover:text-teal transition-colors"><ChevronDown className="h-4 w-4" /></button>
            <button onClick={() => remove(it.id)} className="ml-auto p-2 border border-[#2A201A] text-[#8F877C] hover:border-destructive hover:text-destructive transition-colors"><Trash2 className="h-4 w-4" /></button>
          </div>
        </div>
      ))}
    </div>
  );
};
